import { APP_REMOVE_ALERT } from 'moduleBase/constants';

var appRemoveAlert = function appRemoveAlert(key) {
  return {
    type: APP_REMOVE_ALERT,
    payload: {
      key: key
    }
  };
};

export { appRemoveAlert };